import { __ } from '../utils';
import ConfirmationDialog from './ConfirmationDialog';
import { useAuth } from '@presov.sk/presov-auth-react';
import React from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
};

const LoginModal: React.FC<Props> = ({ open, onClose }) => {
  const { generateLoginUrl } = useAuth();

  return (
    <ConfirmationDialog
      open={open}
      onClose={onClose}
      title={__('Prihlásenie')}
      description={__('Na to, aby ste mohli hlasovať, sa musíte prihlásiť.')}
      confirmLabel={__('Prihlásiť sa')}
      fullWidth
      maxWidth='xs'
      onConfirm={() => {
        window.location.href = generateLoginUrl();
      }}
    ></ConfirmationDialog>
  );
};

export default LoginModal;
